import type { IComponent, IContentComponent, IVersionSection } from "../../../models/Interfaces";
import { copyCollectionItems } from "./propertyeditors/collectionItems";

const copyPropertyValue = (value: string, type: string): string => {
  if (!["htmlitems", "accordionitems", "tabitems", "carousel"].includes(type.toLowerCase())) return value;
  try {
    const items = JSON.parse(value);
    return Array.isArray(items) && items.every(item => item && (typeof item.Id === "number" || typeof item.Id === "string"))
      ? JSON.stringify(copyCollectionItems(items)) : value;
  } catch { return value; }
};

export const componentCopySource = (component: IContentComponent): IComponent => ({
  ...component.BaseComponent,
  Properties: component.BaseComponent.Properties.map(property => ({
    ...property, DefaultValue: copyPropertyValue(property.PublishedValue ?? property.DefaultValue, property.Type?.Name ?? "")
  }))
});

export const emptyCopyColumn = (section: IVersionSection, component: IContentComponent): number | undefined => {
  const span = Math.max(1, component.ColSpan || 1);
  for (let column = 0; column + span <= section.Columns; column++) {
    if (!(section.ContentComponents ?? []).some(item => column < item.ColIndex + Math.max(1, item.ColSpan || 1) && column + span > item.ColIndex)) return column;
  }
  return undefined;
};

export const copyGridPosition = (section: IVersionSection, component: IContentComponent) => ({
  x: component.x ?? component.PosX,
  y: Math.max(0, ...(section.ContentComponents ?? []).map(item => (item.y ?? item.PosY) + (item.h || item.Rows || 10))),
  w: component.w || component.Cols || 2,
  h: component.h || component.Rows || 10
});
